import type { ColGroupDef } from 'ag-grid-enterprise'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatPercent } from '../utils'

export const uaIapEltvSovDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'uaIapEltvSovd30Avg',
      field: 'ua_iap_eltv_sov_d30',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaIapEltvSovd10Avg',
      field: 'ua_iap_eltv_sov_d10',
      headerName: 'D10',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaIapEltvSovd7Avg',
      field: 'ua_iap_eltv_sov_d7',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaIapEltvSovd3Avg',
      field: 'ua_iap_eltv_sov_d3',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaIapEltvSovd0Avg',
      field: 'ua_iap_eltv_sov_d0',
      headerName: 'D0',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'UA IAP eLTV SOV',
}
